export const WEATHER_PRECISION = 2 // https://gis.stackexchange.com/questions/8650/measuring-accuracy-of-latitude-and-longitude

// https://openweathermap.org/api/air-pollution
export const WEATHER_POLLUTION_AQI = {
  1: '#76af53', // Good
  2: '#abb241', // Fair
  3: '#efb944', // Moderate
  4: '#ed5e24', // Poor
  5: '#ec3a1e' // Very poor
}

export const WEATHER_SIMPLIFED_TYPES = {
  Clear: 'Clear',
  Clouds: 'Clouds',
  Rain: 'Rain',
  Drizzle: 'Drizzle',
  Thunderstorm: 'Thunderstorm',
  Snow: 'Snow',
  Atmosphere: 'Atmosphere'
}

// https://openweathermap.org/weather-conditions
export const WEATHER_TYPES = {
  Clear: WEATHER_SIMPLIFED_TYPES.Clear,
  Clouds: WEATHER_SIMPLIFED_TYPES.Clouds,
  Rain: WEATHER_SIMPLIFED_TYPES.Rain,
  Drizzle: WEATHER_SIMPLIFED_TYPES.Drizzle,
  Thunderstorm: WEATHER_SIMPLIFED_TYPES.Thunderstorm,
  Snow: WEATHER_SIMPLIFED_TYPES.Snow,
  Mist: WEATHER_SIMPLIFED_TYPES.Atmosphere,
  Smoke: WEATHER_SIMPLIFED_TYPES.Atmosphere,
  Haze: WEATHER_SIMPLIFED_TYPES.Atmosphere,
  Dust: WEATHER_SIMPLIFED_TYPES.Atmosphere,
  Fog: WEATHER_SIMPLIFED_TYPES.Atmosphere,
  Sand: WEATHER_SIMPLIFED_TYPES.Atmosphere,
  Ash: WEATHER_SIMPLIFED_TYPES.Atmosphere,
  Squall: WEATHER_SIMPLIFED_TYPES.Atmosphere,
  Tornado: WEATHER_SIMPLIFED_TYPES.Atmosphere
}
